// extracted by mini-css-extract-plugin
export default {"tile":"SocialTile_tile__v2sRE"};